<!-- 附件展示组件-吴影茹 -->
<template>
  <div>
    <!-- 空状态 -->
    <OyEmpty
      description="- 暂无附件 -"
      style="margin-bottom: 40px"
      v-if="(!info.packageImgs || info.packageImgs.length == 0) && (!info.packageFiles || info.packageFiles.length == 0)"
    />
    <!-- 图片 -->
    <div
      class="attachment_pic"
      :style="{ gridTemplateColumns: `repeat(${column}, 1fr)`, marginBottom: info.packageFiles && info.packageFiles.length != 0 ? '20px' : '0px' }"
      v-if="info.packageImgs && info.packageImgs.length != 0"
    >
      <a-image v-for="(item, index) in info.packageImgs" :key="index" :src="item" style="width: 100%; aspect-ratio: 5/3; border-radius: 5px" />
    </div>
    <!-- 附件 -->
    <div v-if="info.packageFiles && info.packageFiles.length != 0" class="column_start" style="gap: 8px">
      <div v-for="(item, index) in info.packageFiles" :key="index" class="attachment_url" @click="downUrl(item)">
        {{ item.fileName }}
      </div>
    </div>

    <!-- 预览音频 -->
    <AudioModal v-model:visible="audioVisible" :url="attachUrl" />
    <!-- 预览视频 -->
    <VideoModal v-model:visible="videoVisible" :url="attachUrl" />
  </div>
</template>
            
<script setup lang="ts">
import { onMounted, ref, PropType, watch, computed } from 'vue'

const props = defineProps({
  attachs: {
    type: Array as PropType<any>,
    default: () => []
  },
  column: {
    type: Number,
    default: 3
  }
})

onMounted(() => {})

const info = ref<any>({})

const videoVisible = ref(false)
const audioVisible = ref(false)
const attachUrl = ref('')

// 点击附件
const downUrl = (item) => {
  if (item.fileType == 'mp4') {
    // 视频类型
    attachUrl.value = item.fileUrl
    videoVisible.value = true
  } else if (item.fileType == 'mp3') {
    // 音频类型
    attachUrl.value = item.fileUrl
    audioVisible.value = true
  } else {
    // 其他类型 下载
    window.open(item.fileUrl, '_blank')
  }
}

watch(
  () => props.attachs,
  (newVal) => {
    if (newVal) {
      var imgs: any = []
      var files: any = []

      props.attachs.map((item) => {
        if (item.fileUrl) {
          var lastIndex = item.fileUrl.lastIndexOf('.')
          var str = item.fileUrl.substring(lastIndex + 1)
          if (str == 'png' || str == 'jpeg' || str == 'jpg') {
            imgs.push(item.fileUrl)
          } else {
            files.push({ ...item, fileType: str })
          }
        }
      })

      info.value.packageImgs = imgs
      info.value.packageFiles = files
    }
  },
  { immediate: true, deep: true }
)
</script>
            
<style lang="scss" scoped>
.attachment_pic {
  display: grid;
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
}
.attachment_url {
  width: 100%;
  padding: 8px 15px;
  border-radius: 5px;
  background-color: #f9fafb;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    color: #1677ff;
  }
}
</style>